// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2N420","icon":"SortAdornment_icon__2XCV0","up":"SortAdornment_up__jLbw5","down":"SortAdornment_down__1GOjr","active":"SortAdornment_active__1cwGG"};